"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var store_1 = require("../store/store");
var satcheljs_1 = require("satcheljs");
exports.default = satcheljs_1.mutatorAction('setSubCategoryState', function setSubCategoryState(subCategoryState) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var store;
        return tslib_1.__generator(this, function (_a) {
            store = store_1.getStore();
            store.currentSubCategoryState = subCategoryState;
            return [2 /*return*/];
        });
    });
});
//# sourceMappingURL=setSubCategoryState.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/data/owa-options-store/lib/mutators/setSubCategoryState.js
// module id = 5274
// module chunks = 2